import React from 'react'
import { motion } from 'framer-motion';

const Circles = () => {
  return (
    <motion.div
    initial={{ 
    opacity: 0 
    }}
    animate={{ 
    opacity: [0.05, 0.1, 0.2, 0.4, 0.1, 1.0],
    scale:[0.5,1,1,0.75,0.5],
    borderRadius:["10%","10%", "25%", "25%", "10%"],
    }}
    transition={{ duration: 2.5, repeat: Infinity }}
    className="flex relative justify-center items-center  mt-52 md:mt-2 lg:mt-0 xl:mt-0">
      <div className='absolute border-2 border-[#E7B10A] rounded-full h-[120px] w-[120px] md:animate-ping lg:naimate-ping' />
      <div className='absolute border-2 border-[#a48816] rounded-full h-[150px] w-[150px]' />
      <div className='absolute border-2 border-[#e6771c] rounded-full h-[200px] w-[200px] md:animate-ping lg:naimate-ping' />
      <div className='absolute border-2 border-[#e6771c] rounded-full h-[250px] w-[250px] md:animate-pulse lg:animate-pulse' />
    </motion.div>
  )
}

export default Circles
